import envConfigObj from './envConfig';

const envHelper = {

    setEnvironmentURLs(urlParam) {
            const hostname = urlParam;
            if(hostname.includes("localhost")){
                return  envConfigObj["dev"];
            }
            else if(hostname.includes("dev")){
                return  envConfigObj["dev"];
            } else if(hostname.includes("tst")){
                return  envConfigObj["tst"];
            } else if(hostname.includes("acc")){
                return  envConfigObj["acc"];
            } else {
                return  envConfigObj["prod"];
            }
        
    }
}

export default envHelper;